import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Container,
  Input,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { showModal } from '../../actions';
import { showConfirmationModal } from '../../actions/App';

import {
  APIgetUploadPages,
  APIdeleteUploadPage,
  APIgetUploadPagesUsers,
} from '../../api/UploadPages';

import AdminHeader from '../../components/Admin/Header';
import AdminFooter from '../../components/Admin/Footer';
import AdminUploadPagesList from '../../components/Admin/UploadPages/List';
import UsersFilter from '../../components/Filters/Users';
import EmptyGuestUploads from '../EmptyContainers/GuestUploads';
import TrialNotice from '../../components/TrialNotice';

import { getVisibleItemsText } from '../../helpers';
import { addFlashMessage } from '../../helpers/FlashMessages';
import { getUserSetting } from '../../helpers/Settings';
import {
  handleComponentParams,
  handleURLParams,
} from '../../helpers/URLParams';

import ErrorBoundary from '../../components/ErrorBoundary';
import Loading from '../../components/Loading';

class AdminUploadPages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploadPages: [],
      uploadPagesTotal: 0,
      search: '',
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      orderBy: 'created_at',
      order: 'desc',
      loading: true,
      users: [],
      selectedUser: null,
    };

    this.searchRef = React.createRef();

    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleClearSearch = this.handleClearSearch.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleDeleteUploadPage = this.handleDeleteUploadPage.bind(this);
    this.loadUploadPages = this.loadUploadPages.bind(this);
    this.openUploadPageEditModal = this.openUploadPageEditModal.bind(this);
    this.handleChangeUser = this.handleChangeUser.bind(this);
  }

  componentDidUpdate(prevProps) {
    handleComponentParams(
      false,
      ['page', 'orderBy', 'order', 'user_uuid', 'search'],
      prevProps,
      this.setState.bind(this),
      () => this.loadUploadPages(),
      { orderBy: 'created_at', order: 'desc', search: '' },
    );
  }

  componentDidMount() {
    const { history, location } = this.props;
    const { orderBy, order } = this.state;
    const queryParams = new URLSearchParams(location.search);

    handleComponentParams(
      true,
      ['page', 'orderBy', 'order', 'user_uuid', 'search'],
      null,
      this.setState.bind(this),
      () => this.loadUploadPages(),
      { orderBy: 'created_at', order: 'desc', search: '' },
    );

    if (!queryParams.get('orderBy')) {
      handleURLParams({ orderBy }, history);
    }

    if (!queryParams.get('order')) {
      handleURLParams({ order }, history);
    }
  }

  loadUploadPages(silent = false) {
    const {
      search,
      selectedUser,
      page,
      perPage,
      orderBy,
      order,
    } = this.state;

    if (!silent) {
      this.setState({ loading: true });
    }

    APIgetUploadPages({
      search,
      user_uuid: selectedUser ? selectedUser.uuid : null,
      page,
      per_page: perPage,
      order_by: orderBy,
      order,
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          loading: false,
          uploadPages: data.data,
          uploadPagesTotal: data.meta.total,
        });
      }
    });
  }

  handleChangeOrder(orderBy, order) {
    const { history } = this.props;

    handleURLParams({ orderBy, order, page: 1 }, history);
    this.setState({
      orderBy,
      order,
      page: 1,
    });
  }

  handleChangePage(page) {
    const { history } = this.props;

    handleURLParams({ page }, history);
    this.setState({ page });
  }

  handleChangeSearch(e) {
    const { value } = e.target;
    this.setState({ search: value });
  }

  handleClearSearch(e) {
    e.preventDefault();
    this.searchRef.value = '';

    const { history } = this.props;

    handleURLParams({ search: '', page: 1 }, history);
    this.setState({
      search: '',
      page: 1,
    });
  }

  handleKeyPress(e) {
    const { search } = this.state;
    const { history } = this.props;

    if (e.key === 'Enter') {
      e.preventDefault();
      handleURLParams({ search }, history);
      this.setState({ page: 1 }, () => {
        this.loadUploadPages();
      });
    }
  }

  handleDeleteUploadPage(uploadPageUuid) {
    const {
      intl,
      handleDeleteUploadPage,
      history,
    } = this.props;
    handleDeleteUploadPage(uploadPageUuid, () => {
      addFlashMessage({
        type: 'success',
        text: intl.formatMessage({ defaultMessage: 'The guest upload page has been deleted' }),
      });

      handleURLParams({ page: 1 }, history);
      this.setState({ page: 1 }, () => {
        this.loadUploadPages();
      });
    });
  }

  openUploadPageEditModal(uploadPageUuid) {
    const {
      intl,
      openUploadPageEditModal,
      history,
    } = this.props;

    openUploadPageEditModal(uploadPageUuid, () => {
      addFlashMessage({
        type: 'success',
        text: uploadPageUuid ?
          intl.formatMessage({ defaultMessage: 'Your changes have been saved' }) :
          intl.formatMessage({ defaultMessage: 'A new guest upload page has been created' }),
      });

      if (uploadPageUuid) {
        this.loadUploadPages();
      } else {
        handleURLParams({ page: 1 }, history);
        this.setState({ page: 1 }, () => {
          this.loadUploadPages();
        });
      }
    });
  }

  handleChangeUser(user) {
    const { history } = this.props;
    handleURLParams({ user_uuid: user ? user.uuid : null, page: 1 }, history);

    this.setState({
      selectedUser: user,
      page: 1,
    });
  }

  render() {
    const {
      intl,
    } = this.props;
    const {
      search,
      page,
      perPage,
      uploadPagesTotal,
      loading,
      selectedUser,
    } = this.state;

    return (
      <div className="main-content upload-pages-content">
        <Container fluid>
          <AdminHeader
            title={intl.formatMessage({ defaultMessage: 'Guest upload pages' })}
            feature="upload-pages"
            icon="fa-arrow-up-from-bracket"
            itemName={intl.formatMessage({ defaultMessage: 'guest upload page' })}
            itemsTotal={uploadPagesTotal}
            itemsVisible={getVisibleItemsText(page, perPage, uploadPagesTotal)}
            newItemTitle={intl.formatMessage({ defaultMessage: 'Create guest upload page' })}
            loading={loading}
            handleNewItem={() => { this.openUploadPageEditModal(null); }}
          />
          <TrialNotice feature="upload-pages" />
          <div className="table-filters">
            <UsersFilter
              selectedUser={selectedUser}
              loading={loading}
              loadUsers={APIgetUploadPagesUsers}
              handleChangeUser={this.handleChangeUser}
            />
            {(uploadPagesTotal > 0 || search) && (
              <div className="position-relative inline-search">
                <Input
                  id="upload-page-search"
                  name="upload-page-search"
                  bsSize="sm"
                  innerRef={(ref) => { this.searchRef = ref; }}
                  placeholder={intl.formatMessage({ defaultMessage: 'Type something and press Enter to search' })}
                  disabled={loading}
                  onChange={this.handleChangeSearch}
                  onKeyUp={this.handleKeyPress}
                  value={search}
                />
                {search && (
                  <a
                    href="#clear"
                    className="search-clear"
                    onClick={this.handleClearSearch}
                  >
                    <i className="fas fa-times" />
                  </a>
                )}
              </div>
            )}
          </div>
          {loading ? (
            <Loading />
          ) : (
            <div className="content-wrapper">
              <ErrorBoundary>
                {uploadPagesTotal > 0 ? (
                  <AdminUploadPagesList
                    {...this.state}
                    loadUploadPages={this.loadUploadPages}
                    handleChangeOrder={this.handleChangeOrder}
                    handleDeleteUploadPage={this.handleDeleteUploadPage}
                    openUploadPageEditModal={this.openUploadPageEditModal}
                  />
                ) : (
                  <>
                    {search ? (
                      <div className="nothing-found-wrapper">
                        <h3>{intl.formatMessage({ defaultMessage: 'No guest upload pages found' })}</h3>
                      </div>
                    ) : (
                      <EmptyGuestUploads
                        handleNewItem={() => { this.openUploadPageEditModal(null); }}
                      />
                    )}
                  </>
                )}
              </ErrorBoundary>
              <ErrorBoundary>
                <AdminFooter
                  {...this.state}
                  itemsTotal={uploadPagesTotal}
                  handleChangePage={this.handleChangePage}
                />
              </ErrorBoundary>
            </div>
          )}
        </Container>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  openUploadPageEditModal: (uploadPage = null, callback) => {
    dispatch(showModal('UploadPageEditModal', {
      className: 'modal-edit-upload-page',
      uploadPage,
      notificationCallback: callback,
    }));
  },
  handleDeleteUploadPage: (accountId, callback) => {
    const { intl } = props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({ defaultMessage: 'Are you sure you want to delete this guest upload page?' }),
      onConfirm: () => (
        APIdeleteUploadPage(accountId).then(() => {
          callback();
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
});

AdminUploadPages.propTypes = {
  intl: PropTypes.object.isRequired,
  openUploadPageEditModal: PropTypes.func.isRequired,
  handleDeleteUploadPage: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(injectIntl(connect(null, mapDispatchToProps)(AdminUploadPages)));
